export default "__VITE_ASSET__CNDQ3jzZ__"